import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader.jsx";
import MimicBanner from "./MimicBanner.jsx";

function AppLayout({ currentUser, setCurrentUser }) {
  return (
    <div className="app-shell">
      <div className="app-main">
        <MimicBanner currentUser={currentUser} setCurrentUser={setCurrentUser} />
        <AppHeader currentUser={currentUser} setCurrentUser={setCurrentUser} />
        <main id="print-area" className="app-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
